import type { AxiosResponse } from "axios";
import api from "./api";
import type {
  Assinatura,
  CartaoCredito,
  CreateAssinatura,
  VerifyPlanoClienteReturns,
} from "../types/assinatura";

const BASE_PATH = "/api/v2/app/assinatura";

async function load(
  getnet?: true,
  abortController?: AbortController
): Promise<Assinatura> {
  return await api
    .get<Assinatura>(`${BASE_PATH}${getnet ? "?getnet=true" : ""}`, {
      signal: abortController?.signal,
    })
    .then((response) => response.data);
}

async function create(createAssinatura: CreateAssinatura): Promise<Assinatura> {
  return await api
    .post<
      Assinatura,
      AxiosResponse<Assinatura, CreateAssinatura>,
      CreateAssinatura
    >(BASE_PATH, createAssinatura)
    .then((response) => response.data);
}

async function verifyAndUpdate(): Promise<VerifyPlanoClienteReturns> {
  return await api
    .patch<VerifyPlanoClienteReturns>(`${BASE_PATH}/verify`)
    .then((response) => response.data);
}

async function updateCartaoCredito(
  cartaoCredito: CartaoCredito
): Promise<void> {
  await api
    .patch<{}, AxiosResponse<{}, CartaoCredito>, CartaoCredito>(
      `${BASE_PATH}/cartao`,
      cartaoCredito
    )
    .then((response) => response.data);
}

const assinaturaApi = {
  load,
  create,
  verifyAndUpdate,
  updateCartaoCredito,
};

export default assinaturaApi;
